/* global axios */
import ApiClient from './ApiClient';

export const buildSupplierParams = (page, sort) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

export const buildSearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class SupplierAPI extends ApiClient {
  constructor() {
    super('suppliers', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'name' } = params;
    const requestURL = `${this.url}?${buildSupplierParams(page, sort)}`;
    return axios.get(requestURL);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildSearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }

  getUsers(supplierId) {
    return axios.get(`${this.url}/${supplierId}/users`);
  }

  addUser(supplierId, userId) {
    return axios.post(`${this.url}/${supplierId}/users`, { user_id: userId });
  }

  removeUser(supplierId, userId) {
    return axios.delete(`${this.url}/${supplierId}/users/${userId}`);
  }
}

export default new SupplierAPI();
